/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_New_Password_BodyInputs */

const en_password_reset_new_password_body = /** @type {(inputs: Password_Reset_New_Password_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a new password for your Listening account.`)
};

const es_password_reset_new_password_body = /** @type {(inputs: Password_Reset_New_Password_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una contraseña nueva para tu cuenta de Listening.`)
};

/**
* | output |
* | --- |
* | "Choose a new password for your Listening account." |
*
* @param {Password_Reset_New_Password_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_new_password_body = /** @type {((inputs?: Password_Reset_New_Password_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_New_Password_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_new_password_body(inputs)
	return en_password_reset_new_password_body(inputs)
});